import React from "react";
import { ViewOrders } from "../../pages";

const ViewOrdersContainer = ({ closeModal, data }) => {
    return (
        <ViewOrders
        closeModal={closeModal}
        data={data}
        />
    )
}

export default ViewOrdersContainer;